import React from 'react';
import { NumberedList, ListItem } from '@fiverr-private/list';
import { ViewComponentProps } from '../..';
import { ScreeningQuestionsContent } from '../utils/types';

export const ViewScreeningQuestions: React.FC<ViewComponentProps<ScreeningQuestionsContent>> = ({ section }) => {
  const questions = section?.content?.questions || [];

  if (questions.length === 0) {
    return null;
  }

  return (
    <NumberedList gap="2">
      {questions.map((question) => (
        <ListItem key={question.id} color="bodyPrimary">
          {question.text}
        </ListItem>
      ))}
    </NumberedList>
  );
};
